var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequests(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dark-Pink-24"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Color",
    cx: 31.9998,
    cy: 32.4427,
    r: 13.3333,
    fill: "url(#paint0_linear_478_4216)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Glass",
    filter: "url(#filter0_bi_478_4216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 16.4427C10.6665 13.4972 13.0543 11.1094 15.9998 11.1094H23.9998C26.9454 11.1094 29.3332 13.4972 29.3332 16.4427V24.4427C29.3332 27.3882 26.9454 29.776 23.9998 29.776H15.9998C13.0543 29.776 10.6665 27.3882 10.6665 24.4427V16.4427Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 16.4427C10.6665 13.4972 13.0543 11.1094 15.9998 11.1094H23.9998C26.9454 11.1094 29.3332 13.4972 29.3332 16.4427V24.4427C29.3332 27.3882 26.9454 29.776 23.9998 29.776H15.9998C13.0543 29.776 10.6665 27.3882 10.6665 24.4427V16.4427Z",
    fill: "url(#paint1_linear_478_4216)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 40.4427C10.6665 37.4972 13.0543 35.1094 15.9998 35.1094H23.9998C26.9454 35.1094 29.3332 37.4972 29.3332 40.4427V48.4427C29.3332 51.3882 26.9454 53.776 23.9998 53.776H15.9998C13.0543 53.776 10.6665 51.3882 10.6665 48.4427V40.4427Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 40.4427C10.6665 37.4972 13.0543 35.1094 15.9998 35.1094H23.9998C26.9454 35.1094 29.3332 37.4972 29.3332 40.4427V48.4427C29.3332 51.3882 26.9454 53.776 23.9998 53.776H15.9998C13.0543 53.776 10.6665 51.3882 10.6665 48.4427V40.4427Z",
    fill: "url(#paint2_linear_478_4216)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6665 16.4427C34.6665 13.4972 37.0543 11.1094 39.9998 11.1094H47.9998C50.9454 11.1094 53.3332 13.4972 53.3332 16.4427V24.4427C53.3332 27.3882 50.9454 29.776 47.9998 29.776H39.9998C37.0543 29.776 34.6665 27.3882 34.6665 24.4427V16.4427Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6665 16.4427C34.6665 13.4972 37.0543 11.1094 39.9998 11.1094H47.9998C50.9454 11.1094 53.3332 13.4972 53.3332 16.4427V24.4427C53.3332 27.3882 50.9454 29.776 47.9998 29.776H39.9998C37.0543 29.776 34.6665 27.3882 34.6665 24.4427V16.4427Z",
    fill: "url(#paint3_linear_478_4216)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6665 40.4427C34.6665 37.4972 37.0543 35.1094 39.9998 35.1094H47.9998C50.9454 35.1094 53.3332 37.4972 53.3332 40.4427V48.4427C53.3332 51.3882 50.9454 53.776 47.9998 53.776H39.9998C37.0543 53.776 34.6665 51.3882 34.6665 48.4427V40.4427Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6665 40.4427C34.6665 37.4972 37.0543 35.1094 39.9998 35.1094H47.9998C50.9454 35.1094 53.3332 37.4972 53.3332 40.4427V48.4427C53.3332 51.3882 50.9454 53.776 47.9998 53.776H39.9998C37.0543 53.776 34.6665 51.3882 34.6665 48.4427V40.4427Z",
    fill: "url(#paint4_linear_478_4216)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9332 16.4427C10.9332 13.6445 13.2016 11.376 15.9998 11.376H23.9998C26.7981 11.376 29.0665 13.6445 29.0665 16.4427V24.4427C29.0665 27.241 26.7981 29.5094 23.9998 29.5094H15.9998C13.2016 29.5094 10.9332 27.241 10.9332 24.4427V16.4427ZM10.9332 40.4427C10.9332 37.6445 13.2016 35.376 15.9998 35.376H23.9998C26.7981 35.376 29.0665 37.6445 29.0665 40.4427V48.4427C29.0665 51.241 26.7981 53.5094 23.9998 53.5094H15.9998C13.2016 53.5094 10.9332 51.241 10.9332 48.4427V40.4427ZM34.9332 16.4427C34.9332 13.6445 37.2016 11.376 39.9998 11.376H47.9998C50.7981 11.376 53.0665 13.6445 53.0665 16.4427V24.4427C53.0665 27.241 50.7981 29.5094 47.9998 29.5094H39.9998C37.2016 29.5094 34.9332 27.241 34.9332 24.4427V16.4427ZM34.9332 40.4427C34.9332 37.6445 37.2016 35.376 39.9998 35.376H47.9998C50.7981 35.376 53.0665 37.6445 53.0665 40.4427V48.4427C53.0665 51.241 50.7981 53.5094 47.9998 53.5094H39.9998C37.2016 53.5094 34.9332 51.241 34.9332 48.4427V40.4427Z",
    stroke: "url(#paint5_linear_478_4216)",
    strokeOpacity: 0.1,
    strokeWidth: 0.533333
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_478_4216",
    x: 7.6665,
    y: 8.10938,
    width: 48.6665,
    height: 48.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_478_4216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_478_4216",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_478_4216"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_478_4216",
    x1: 19.7776,
    y1: 24.4427,
    x2: 48.8465,
    y2: 28.4801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_478_4216",
    x1: 12.4443,
    y1: 19.6427,
    x2: 58.9545,
    y2: 26.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_478_4216",
    x1: 12.4443,
    y1: 19.6427,
    x2: 58.9545,
    y2: 26.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_478_4216",
    x1: 12.4443,
    y1: 19.6427,
    x2: 58.9545,
    y2: 26.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_478_4216",
    x1: 12.4443,
    y1: 19.6427,
    x2: 58.9545,
    y2: 26.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_478_4216",
    x1: 11.9998,
    y1: 13.0488,
    x2: 53.3332,
    y2: 13.0488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD84DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FD6FA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/requests.560338662b742119f27a17c411c8067c.svg";
export { ForwardRef as ReactComponent };